import * as types from "../actions/actionsTypes";

let initialState = {
  items: [],
};

const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ITEMS:
      return {
        ...state,
        items: action.data,
      };

    case types.RESET_ITEMS:
      return {
        items: [],
      };

    default:
      return state;
  }
};

export default newsReducer;
